module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium_1.c7c40ffd.ttf";